import { editNickName, setAvatar, upload } from "@/apis/user";
import { useUserInfoStore } from "@/stores/userInfo";
import { UploadAvatarParams } from "@/types/Api/User/Avatar";

export const useSetup = () => {
  const userStore = useUserInfoStore()();

  const fetchEditNickName = async ({ nickname }: { nickname: string }) => {
    const response = await editNickName({ nickname });
    if (response.ok) {
      // TODO: 请求失败的处理
      // 重新请求用户信息
    } else {
      // TODO: 请求失败的处理
    }
  };

  const fetchUserInfo = async () => {
    userStore.updateUserInfo();
  };

  const fetchUploadAvatar = async (params: UploadAvatarParams) => {
    const response: any = await upload(params);
    if (response.ok) {
      // TODO: 请求失败的处理
      return response.data.name;
    } else {
      // TODO: 请求失败的处理
      return "";
    }
  };
  const fetchSetAvatar = async (params: { avatarAddr: string }) => {
    const response: any = await setAvatar(params);

    if (response.ok) {
      // TODO: 请求失败的处理
      // return response.data.name
    } else {
      // TODO: 请求失败的处理
      return "";
    }
  };
  return {
    fetchEditNickName,
    fetchUserInfo,
    fetchUploadAvatar,
    fetchSetAvatar,
    userInfo: userStore.userInfo,
  };
};
